/**
 * Supplier cost prices are quoted in the supplier's own currency, which the
 * table shows once in its own column, so amounts are formatted as bare grouped
 * numbers rather than repeating the code in every cell.
 */
export function formatAmount(amount: number | null | undefined): string {
  if (amount === null || amount === undefined || !Number.isFinite(amount)) {
    return '—';
  }

  return new Intl.NumberFormat('en-AU', { maximumFractionDigits: 2 }).format(amount);
}
